<template>
  <v-container fluid>
    <v-layout row wrap text-center winners__not-found v-if="serverError">
      <v-flex xs12>
        <h1>{{ serverError }}</h1>
      </v-flex>
      <v-flex xs12 py-0 pb-5>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="!serverError">
      <v-flex xs12>
        <h1>{{ $t("pagesTenders.calllist.title") }}</h1>
      </v-flex>
      <v-flex xs12 py-0>
        <v-divider />
      </v-flex>
    </v-layout>

    <v-layout align-start justify-start row wrap filters v-if="!serverError">
      <v-flex shrink>
        <div class="winners__date">
          <v-menu
            ref="date_from"
            v-model="date_from"
            :close-on-content-click="false"
            offset-y
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="winners_date_from"
                :placeholder="$t('pagesTenders.calllist.date')"
                prepend-icon="event"
                v-on="on"
                v-on:blur="formatDateFrom"
                v-mask="'##.##.####'"
                class="pt-0 mt-0"
                readonly
                return-masked-value
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="winnersDateFrom"
              :max="new Date().toISOString().substr(0, 10)"
              @change="saveDateFrom"
              llocale="ru-ru"
              first-day-of-week="1"
              no-title
            ></v-date-picker>
          </v-menu>
        </div>
      </v-flex>

      <v-divider vertical></v-divider>
      <v-flex shrink>
        <v-select
          v-model="filterUserSelectModel"
          :items="filterUserSelectList"
          iitem-text="name"
          menu-props="overflowY"
          class="mt-0 pt-0"
          hide-details
          @change="changeUserFilter"
        ></v-select>
      </v-flex>

      <!-- <v-flex shrink pl-0>
                <v-icon color="primary" @click="getShit">history</v-icon>
      </v-flex>-->
    </v-layout>

    <v-layout row wrap block winners mx-0>
      <v-flex xs12 px-0 v-if="isLoaded && !serverError">
        <v-data-table
          :headers="headers"
          :items="winnersFiltered"
          :loading="!isLoaded"
          sort-deprecated-by="guaranteeing"
          :sort-desc="true"
          :footer-props="{ 'items-per-page-options': [250] }"
          :items-per-page="250"
          class="winners__table"
        >
          <v-progress-linear
            v-slot:progress
            color="primary"
            v-if="isLoaded"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item="{ item }">
            <tr @click="openTender(item.tender.id)">
              <td class="text-center">
                <v-icon
                  v-if="item.direction == 2"
                  large
                  color="green darken-2"
                  :title="$t('pagesTenders.calllist.direction.out')"
                  >mdi-arrow-up</v-icon
                >
                <v-icon
                  v-else
                  large
                  color="blue darken-2"
                  :title="$t('pagesTenders.calllist.direction.in')"
                  >mdi-arrow-down</v-icon
                >
              </td>
              <td class="text-center" v-if="roleCheck != 30">
                {{ item.user.full_name }}
              </td>
              <td class="text-center">{{ item.created_at | formatDate(2) }}</td>
              <td class="text-left">
                <div v-if="item.tender">
                  <v-chip class="ma-2 ml-0" label :link="false"
                    >{{ $t("pagesTenders.calllist.bg") }}:
                    {{ item.tender.guaranteeing | formatPrice }}</v-chip
                  >
                  <v-chip class="ma-2" label outlined :link="false"
                    >{{ $t("pagesTenders.calllist.inn") }}:
                    {{ item.tender.winner_inn }}</v-chip
                  >
                  <v-chip class="ma-2" label outlined :link="false"
                    >{{ $t("pagesTenders.calllist.date") }}:
                    {{ item.tender.protokol_date | formatDate }}</v-chip
                  >
                  <div>{{ item.tender.winner_name }}</div>
                  <div>
                    {{ $t("pagesTenders.calllist.num")
                    }}{{ item.tender.notification_number }}
                    {{ item.tender.name }}
                  </div>
                </div>
                <div v-else>
                  {{ item.historyCreate ? item.historyCreate.page : "" }}
                </div>
              </td>

              <td class="text-left">
                {{ getParamsValue(item.params, "comment") }}
              </td>
              <td class="text-center">{{ getStatusName(item) }}</td>
              <td class="text-center">{{ item.phone }}</td>
              <td class="text-center">{{ item.call_time }}</td>
            </tr>
          </template>

          <template v-slot:no-data>
            <div class="winners--empty">
              <h2>{{ $t("pagesTenders.calllist.emptyData") }}</h2>
            </div>
          </template>
        </v-data-table>
      </v-flex>

      <v-flex xs12 mt-5 v-else>
        <skeleton />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import statusNames from "@/utils/data/statuses";
import { mask } from "vue-the-mask";
import Skeleton from "@/components/skeleton";
import formatDate from "@/mixins/filters/formatDate";
import formatPrice from "@/mixins/filters/formatPrice";

import i18n from "@/services/i18n";

export default {
  name: "CallList",
  directives: { mask },
  mixins: [formatDate, formatPrice],
  data: () => ({
    winners: null,
    isLoaded: false,

    columns: [],
    pagination: {
      rowsPerPage: 500,
      /*sortBy: "guaranteeing",*/
      /*descending: true*/
    },
    serverError: null,
    date_from: false,
    winners_date_from: null,
    winnersDateFrom: null, // new Date().toISOString().substr(0, 10),
    statusNames,
    filterUserSelectModel: "",
    filterUserSelectList: null,
    filterUserSelectDefault: i18n.t("pagesTenders.calllist.allUsers"),
  }),

  components: { Skeleton },
  methods: {
    getParamsValue(params, name) {
      if (params && params[name]) return params[name];
      return null;
    },
    dateToDMY(date) {
      var d = date.getDate();
      var m = date.getMonth() + 1; //Month from 0 to 11
      var y = date.getFullYear();
      return (
        "" + (d <= 9 ? "0" + d : d) + "." + (m <= 9 ? "0" + m : m) + "." + y
      );
    },

    async getList() {
      this.isLoaded = false;

      await apiCallTrue({
        url: "v1/call-center/list-history",
        params: {
          date: this.winnersDateFrom,
          type: 4,
        },
      })
        .then((response) => {
          this.winners = response.data.data;
          this.isLoaded = true;
          this.__startUserFilterList();
        })
        .catch((error) => {
          this.serverError = error.message;
        });
    },

    openTender(id) {
      Object.assign(document.createElement("a"), {
        target: "_blank",
        href: "/tenders/" + id,
      }).click();
      //this.$router.push({ name: "ShowTender", params: { id: id } });
    },
    changeUserFilter() {
      let params = { date: this.winnersDateFrom };
      if (
        this.filterUserSelectModel &&
        this.filterUserSelectModel != this.filterUserSelectDefault
      )
        params.user = this.filterUserSelectModel;

      if (this.filterUserSelectList) {
        let removeItems = [];
        for (let p in this.filterUserSelectList) {
          if (this.filterUserSelectList[p] == this.filterUserSelectDefault)
            continue;
          if (this.filterUserSelectList[p] == this.filterUserSelectModel)
            continue;

          if (this.winners) {
            let exists = false;
            for (let i in this.winners) {
              if (
                this.winners[i].user.full_name == this.filterUserSelectList[p]
              ) {
                exists = true;
                break;
              }
            }
            if (!exists) removeItems.push(this.filterUserSelectList[p]);
          }
        }

        if (removeItems) {
          for (let p in removeItems) {
            let indexFounded = this.filterUserSelectList.indexOf(
              removeItems[p]
            );
            if (indexFounded === -1) continue;
            this.filterUserSelectList.splice(indexFounded, 1);
          }
        }
      }

      //add history push router
      this.addRouteHistory(params);
    },
    saveDateFrom(date, isFirstCreated) {
      console.log("DDDD", date);
      this.$refs.date_from.save(date);
      this.winners_date_from = this.dateToDMY(new Date(this.winnersDateFrom));
      if (!isFirstCreated) {
        let params = { date: this.winnersDateFrom };
        if (
          this.filterUserSelectModel &&
          this.filterUserSelectModel != this.filterUserSelectDefault
        )
          params.user = this.filterUserSelectModel;
        this.addRouteHistory(params);
      }
      this.getList();
    },
    formatDateFrom() {
      if (this.winners_date_from) {
        this.winnersDateFrom = this.winners_date_from
          .split(".")
          .reverse()
          .join("-");
      }
    },
    addRouteHistory(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
          "?" +
          Object.keys(params)
            .map((key) => {
              return (
                encodeURIComponent(key) + "=" + encodeURIComponent(params[key])
              );
            })
            .join("&")
      );
    },
    getStatusName(item) {
      if (!item.params) return "";
      if (item.params.status) {
        const id = item.params.status;
        return this.statusNames.call[id].name
          ? this.statusNames.call[id].name
          : "";
      }
      return item.last_status;
    },

    getColumns(role) {
      return [
        {
          text: i18n.t("pagesTenders.calllist.table.fields.direction"),
          name: i18n.t("pagesTenders.calllist.table.fields.direction"),
          value: "direction",
          align: "center",
          sortable: true,
          disabledColumn: false,
        },
        ...(role == 30
          ? []
          : [
              {
                text: i18n.t("pagesTenders.calllist.table.fields.user"),
                name: i18n.t("pagesTenders.calllist.table.fields.user"),
                value: "user",
                align: "left",
                sortable: true,
                disabledColumn: true,
              },
            ]),
        {
          text: i18n.t("pagesTenders.calllist.table.fields.time"),
          name: i18n.t("pagesTenders.calllist.table.fields.time"),
          value: "created_at",
          align: "center",
          sortable: true,
          disabledColumn: false,
        },
        {
          text: i18n.t("pagesTenders.calllist.table.fields.page"),
          name: i18n.t("pagesTenders.calllist.table.fields.page"),
          value: "page",
          align: "left",
          sortable: false,
          disabledColumn: false,
        },
        {
          text: i18n.t("pagesTenders.calllist.table.fields.comment"),
          name: i18n.t("pagesTenders.calllist.table.fields.comment"),
          value: "comment",
          align: "left",
          sortable: true,
          disabledColumn: false,
        },
        {
          text: i18n.t("pagesTenders.calllist.table.fields.status"),
          name: i18n.t("pagesTenders.calllist.table.fields.status"),
          value: "status",
          align: "center",
          sortable: true,
          disabledColumn: false,
        },
        {
          text: i18n.t("pagesTenders.calllist.table.fields.phone"),
          name: i18n.t("pagesTenders.calllist.table.fields.phone"),
          value: "phone",
          align: "center",
          sortable: true,
          disabledColumn: false,
        },
        {
          text: i18n.t("pagesTenders.calllist.table.fields.time"),
          name: i18n.t("pagesTenders.calllist.table.fields.time"),
          value: "time",
          align: "center",
          sortable: false,
          disabledColumn: false,
        },
      ];
    },

    __startUserFilterList() {
      if (!this.filterUserSelectList) this.filterUserSelectList = [];

      if (this.winners) {
        for (let p in this.winners) {
          //check exist
          let isContinue = false;
          for (let i in this.filterUserSelectList) {
            if (
              this.filterUserSelectList[i] == this.winners[p].user.full_name
            ) {
              isContinue = true;
              break;
            }
          }
          if (isContinue) continue;
          this.filterUserSelectList.push(this.winners[p].user.full_name);
        }
        //var items = [4,5,4,6,3,4,5,2,23,1,4,4,4]
        //var uniqueItems = Array.from(new Set(items))
        this.filterUserSelectList.sort();
      }

      //check model exist
      if (
        this.filterUserSelectModel &&
        this.filterUserSelectModel != this.filterUserSelectDefault
      ) {
        if (
          this.filterUserSelectList.indexOf(this.filterUserSelectModel) === -1
        ) {
          this.filterUserSelectList.push(this.filterUserSelectModel);
          this.filterUserSelectList.sort();
        }
      }

      this.filterUserSelectList.unshift(this.filterUserSelectDefault);

      if (!this.filterUserSelectModel)
        this.filterUserSelectModel = this.filterUserSelectDefault;
    },
  },
  computed: {
    headers() {
      return this.columns;
    },
    ...mapState({
      role: (state) => state.user.profile.role,
    }),
    roleCheck() {
      return this.role ? this.role : 0;
    },

    winnersFiltered() {
      if (!this.winners) return [];
      return this.winners.filter((val) => {
        if (
          this.filterUserSelectModel &&
          this.filterUserSelectModel != this.filterUserSelectDefault
        ) {
          if (val.user.full_name != this.filterUserSelectModel) return false;
        }
        return true;
      });
    },
  },
  mounted() {
    this.__startUserFilterList();
    this.columns = this.getColumns(this.roleCheck);
    this.winnersDateFrom = new Date().toISOString().substr(0, 10);
    if (this.$router.history.current && this.$router.history.current.query) {
      if (this.$router.history.current.query.date)
        this.winnersDateFrom = this.$router.history.current.query.date;
      if (this.$router.history.current.query.user) {
        this.filterUserSelectModel = this.$router.history.current.query.user;
      }
    }
    this.saveDateFrom(this.winnersDateFrom);
  },
};
</script>

<style lang="scss">
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child),
table.v-table thead th {
  padding: 0 10px !important;
}

.filters {
  padding: 16px 0;

  &--disabled {
    opacity: 0.2;
  }

  .v-select__selections {
    strong {
      font-size: 13px;
      font-weight: 400;
      padding-left: 10px;
    }
    input {
      width: 5px;
      padding: 5px 0;
    }
  }
  .v-select__selection {
    font-size: 13px;
    margin: 6px 0 6px 10px;
    white-space: nowrap;
  }
  &__item {
    span {
      cursor: pointer;
      // display: block;
      // border: 1px solid #ccc;
      // padding: 2px 15px;
      // border-radius: 15px;
      color: #aaa;
      // background: transparent;
      // transition: all 0.3s ease;
    }
    &-button {
      margin: 0 !important;
      box-shadow: 0 0 0 !important;
      cursor: pointer;
      display: block;
      border: 1px solid #ccc;
      padding: 6px 10px 5px !important;
      border-radius: 15px !important;
      background: transparent !important;
      transition: all 0.3s ease;
      height: auto !important;
      min-width: 10px;

      &::before {
        display: none;
      }

      &:hover {
        border-color: #000 !important;

        .v-btn__content {
          color: #000 !important;
        }
      }

      .v-btn__content {
        padding: 0 !important;
        color: #aaa !important;
        font-weight: 400 !important;
      }

      .v-ripple__container {
        display: none !important;
      }
    }

    &--active:not(.filters--disabled) {
      .filters__item-button {
        border-color: #404ce6 !important;
        background: #404ce6 !important;
        .v-btn__content {
          color: #fff !important;
        }

        &:hover {
          border-color: #404ce6 !important;
          background: #404ce6 !important;

          .v-btn__content {
            color: #fff !important;
          }
        }
      }
    }
  }

  &__search {
    &-select {
      max-width: 100px;
    }

    &-button {
      margin: 0 !important;
      box-shadow: 0 0 0 !important;
      cursor: pointer;
      display: block;
      border: 1px solid #ccc;
      padding: 3px 15px 3px !important;
      border-radius: 15px !important;
      background: transparent !important;
      transition: all 0.3s ease;
      height: auto;
      min-width: 10px;

      &::before {
        display: none;
      }

      &:hover {
        border-color: #000 !important;

        .v-btn__content {
          color: #000 !important;
        }
      }

      .v-btn__content {
        padding: 0 !important;
        color: #aaa !important;
        font-weight: 400 !important;
      }
      .v-ripple__container {
        display: none !important;
      }
    }
  }
}

.winners {
  .theme--light.v-table tbody tr:not(:last-child) {
    border: 0;
  }
  &__date {
    max-width: 150px !important;
  }
  &__table {
    thead {
      tr:hover {
        background: #fff !important;
      }
    }
    tr {
      background: #fff !important;
      cursor: pointer;

      &[active] {
        background: #fff !important;
      }
      position: relative;
      &:hover {
        background: rgba(74, 116, 252, 0.1) !important;
        .products__table-line {
          opacity: 1;
        }
        .products__table-actions {
          opacity: 1;
        }
      }
      // td:nth-child(1),
      // th:nth-child(1) {
      //     padding: 0 0 0 32px !important;
      //     position: relative;
      //     .v-icon {
      //         color: transparent !important;
      //     }
      //     .v-input--selection-controls__ripple {
      //         display: inline-block;
      //         vertical-align: middle;
      //         color: transparent;
      //         border: 1px solid #ccc;
      //         height: 14px;
      //         width: 14px;
      //         border-radius: 0;
      //         top: -2px;
      //         left: -2px;
      //         &::after {
      //             content: "";
      //             position: absolute;
      //             top: 1px;
      //             right: 1px;
      //             bottom: 1px;
      //             left: 1px;
      //             background: #4b74ff;
      //             opacity: 0;
      //         }
      //         &.accent--text {
      //             &::after {
      //                 opacity: 1;
      //             }
      //         }
      //     }
      // }
      // td:nth-child(2),
      // th:nth-child(2) {
      //     padding-left: 0 !important;
      // }
      th {
        font-size: 12px !important;
        &.active {
          color: #4b74ff !important;
        }
      }
      &:nth-child(2n + 2),
      &[active]:nth-child(2n + 2) {
        background: #f5f5f5 !important;
      }
    }
    &-actions {
      opacity: 0;
      font-size: 14px !important;
      padding-right: 32px !important;
      text-align: right;
      &-trigger {
        color: #ff0000;
        cursor: pointer;
        .v-icon {
          font-size: 16px;
          margin-right: 2px;
        }
      }
      &-confirm {
        padding: 20px 24px;
        border-radius: 4px;
        background: #fff;
        text-align: right;
        width: 370px;
      }
      &-title {
        text-align: center;
        padding-bottom: 16px;
      }
      &-message {
        float: left;
        max-width: 40%;
        font-size: 12px;
        color: #ff0000;
        text-align: left;
      }
    }
    &-pagination {
      display: inline-block;
      vertical-align: top;
      text-align: center;
      height: 32px;
      width: 32px;
      border-radius: 2px;
      border: 1px solid #aaa;
      margin: 0 10px;
      cursor: pointer;
      &::after {
        content: "";
        display: inline-block;
        vertical-align: top;
        border: 1px solid #666;
        border-width: 1px 1px 0 0;
        height: 6px;
        width: 6px;
        margin-top: 7px;
        position: relative;
      }
      &--left {
        &::after {
          transform: rotate(-135deg);
          right: -1px;
        }
      }
      &--right {
        &::after {
          transform: rotate(45deg);
          left: -1px;
        }
      }
      &--disabled {
        border-color: #eee;
        cursor: no-drop;
        &::after {
          border-color: #eee;
        }
      }
      &-text {
        display: inline-block;
        vertical-align: top;
        margin-top: 5px;
        min-width: 100px;
        text-align: center;
      }
      &-select {
        min-width: 20px;
      }
    }
    &-line {
      width: 3px;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: #4b74ff;
      opacity: 0;
    }

    &-contacts {
      background: none !important;
      color: #ff0000 !important;
      box-shadow: 0 0 0 !important;
      border: 0 !important;
      display: inline-block;
      vertical-align: top;
      padding: 0;
      height: auto;
      min-width: 10px;

      .v-ripple__container {
        display: none !important;
      }
      .v-btn__content {
        padding: 0 !important;
      }
      &::before {
        display: none;
      }
    }
    &-offer {
      white-space: nowrap;
    }
    &-date {
      white-space: nowrap;
    }
  }

  &__not-found {
    padding-top: 200px;
  }
  &--empty {
    min-height: 500px;
    line-height: 500px;
    vertical-align: middle;
    text-align: center;
  }
}

.btn {
  display: inline-block;
  vertical-align: top;
  border: 1px solid #ff0000;
  background: #ff0000;
  padding: 5px 15px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 10px;
  &--ghost {
    background: none;
    border-color: #ccc;
    color: #aaa;
  }
}
.theme--light.v-table {
  background: rgba(255, 255, 255, 0.7) !important;
}
// .v-text-field > .v-input__control > .v-input__slot:before,
// .v-text-field > .v-input__control > .v-input__slot:after {
//     display: none;
// }
// .v-input--selection-controls__input {
//     .v-icon {
//         color: transparent !important;
//     }
// }
// .v-input--selection-controls__ripple {
//     display: inline-block;
//     vertical-align: middle;
//     color: transparent;
//     border: 1px solid #ccc;
//     height: 14px;
//     width: 14px;
//     border-radius: 0;
//     top: -2px;
//     left: -2px;
//     &::after {
//         content: "";
//         position: absolute;
//         top: 1px;
//         right: 1px;
//         bottom: 1px;
//         left: 1px;
//         background: #4b74ff;
//         opacity: 0;
//     }
//     &.accent--text,
//     &.primary--text {
//         &::after {
//             opacity: 1;
//         }
//     }
// }
.v-list__tile__action {
  min-width: 32px;
  position: relative;
}
.v-list__tile {
  height: 40px;
}
.v-list__tile__title {
  line-height: 16px;
  height: 16px;
}
.select-all {
  top: 5px;
}
.v-text-field .v-input__append-inner {
  padding: 0;
  margin: 2px 0 0;
}
.v-list--disabled {
  opacity: 0.6;
}
.is_client {
  font-weight: 700;
}
</style>
